/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */

import styled from '@emotion/styled';
import BreadCrumbs from '@base/BreadCrumbs/BreadCrumbs';
import breadcrumbs, { goBack } from '@utils/breadcrumbs';
import { Spacings } from '@styles/index';
import { getIsSubscribedToOffline } from '@api/selectors/subscription';
import useMyInfo from '@api/hooks/auth/useMyInfo';

const TopBar = styled.div`
  margin-bottom: ${Spacings.SPACING_10B};
  transition: all 300ms ease;
`;

const CourseBreadcrumbs = ({
  isEducatorSide,
  isTestSeries,
  goalData,
  plusCourse
}) => {
  const props = {};
  const isOfflineSubscription = useMyInfo(
    getIsSubscribedToOffline(goalData.uid)
  );
  if (isEducatorSide)
    props.tags = [
      {
        title: isTestSeries ? 'Test series' : 'Plus courses',
        as: '/educator/courses/plus-courses',
        href: '/educator/courses/[type]'
      }
    ];
  else {
    props.onBackClick = goBack;
    if (isTestSeries)
      props.tags = breadcrumbs.getTestSeriesTags(
        goalData,
        isOfflineSubscription
      );
    else
      props.tags = breadcrumbs.getCourseTags(
        goalData,
        plusCourse?.topicGroups?.[0],
        isOfflineSubscription
      );
  }
  return (
    <TopBar>
      <BreadCrumbs {...props} />
    </TopBar>
  );
};

export default CourseBreadcrumbs;
